module.exports = __webpack_public_path__ + "img/relax.e198ee08.svg";